<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true" v-if="power.indexOf(42)!=-1">增加</Button>
            <Button type="info" @click="qiehuan" v-if="power.indexOf(41)!=-1">切换人工/机器人</Button>
            <cite>|</cite>
            提示：点击二维码可放大查看
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
      <el-table-column prop="fid" label="二维码图片" :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <a target="_blank" :href="'/api/upload/online/'+scope.row.fid">
            <img :src="'/api/upload/online/'+scope.row.fid" style="width:50px;"/>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注信息" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="type" label="类型" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="state" label="状态" :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <span v-if="scope.row.state==='正常'" style="color: #19be6b">正常</span>
          <span v-if="scope.row.state==='停用'" style="color: red">停用</span>
        </template>
      </el-table-column>
        <el-table-column prop="msg" label="操作" width="120" fixed="right" v-if="power.indexOf(42)!=-1">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="100">
				<FormItem label="二维码图片" required>
          <UploadOne  v-model="detail.fid"></UploadOne>
				</FormItem>
        <FormItem label="类型" required>
          <Select v-model="detail.type">
            <Option value="人工" label="人工"></Option>
            <Option value="机器人" label="机器人"></Option>
          </Select>
        </FormItem>
				<FormItem label="备注信息" required>
					<Input v-model="detail.note"/>
				</FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import UploadOne from "../../public/upload/UploadOne";
  export default {
    components:{UploadOne},
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/ziliao/ziliaoLingqu/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      qiehuan(){
        let that = this;
        this.$axios.get(this.baseUrl+'qiehuan').then(function(rs){
          that.toast(rs.data);
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ziliao/ZiliaoLingqu.vue